<template>
  <f7-page no-toolbar no-swipeback name="financial" class="page-center" >
    <f7-navbar innerClass="navbar-inner">
      <f7-nav-left>
        <f7-link @click="$f7router.back()">
          <i class="f7-icons">chevron_left</i>
        </f7-link>
      </f7-nav-left>
      <f7-nav-title v-if="type==1">{{ $t("home_0178") }}</f7-nav-title>
      <f7-nav-title v-else-if="type==2">{{ $t("home_0180") }}</f7-nav-title>
      <f7-nav-title v-else-if="type==3">{{ $t("home_0085") }}</f7-nav-title>
      <f7-nav-right>
        <f7-link></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <div class="content" v-if="newsbymemberInfo">
      <div class="newsInfo">
        <div class="title">{{ newsbymemberInfo.Title }}</div>
        <div class="bottom">
          <!-- <div>{{ $t("home_0169") }}: 1200</div> -->
          <div >
            <span>{{ newsbymemberInfo.ReleaseTS | time2}}</span>

            <span class="good" @click="newsLike(newsbymemberInfo.Id,!goodflag)">
              <img  width="16" :src="`../../static/images/yt999/${(goodflag)? 'good2' : 'good'}.png`"  />
              <span style="margin-left: 4px;">{{ goodnum }}</span>
            </span>
          </div>
          <div></div>
        </div>
      </div>
      <div class="video" v-if="videoSrc" style="margin-top: 10px;font-size: 0;">
        <video ref="myVideo" controls playsinline webkit-playsinline width="100%"></video>
      </div>
      <div class="sub" v-if="newsbymemberInfo.SubTitle">{{ newsbymemberInfo.SubTitle }}</div>
      <div v-html="newsbymemberInfo.ContentTextMobile"></div>
    </div>

  </f7-page>
</template>

<script>
import Hls from 'hls.js';
import { getCookie } from "@/config/utils";
import { newsbymemberget, getlikecount, newsLike} from "../../axios/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      newsbymemberInfo:{},
      type:0,
      likecountlist: [],
      likeFlag: true,
      goodflag: false,
      goodnum: 0,

      videoSrc: null

    };
  },
  watch: {},
  computed: {},
  methods: {
    newsbymemberget(id){
      const self = this;
      const param = { "Id":id };
      const d = { data: JSON.stringify(param) };
      newsbymemberget(d).then((data) => {
        if (data.Code === "NoError") {
          self.newsbymemberInfo = data.Data;

          self.videoSrc = data.Data.VideoUrl;
          this.$nextTick(() => {
            if (Hls.isSupported()) {
              const video = this.$refs.myVideo;
              const hls = new Hls();
              hls.loadSource(self.videoSrc);
              hls.attachMedia(video);
              hls.on(Hls.Events.MANIFEST_PARSED, () => {
                // video.play();
              });
            } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
              video.src = self.videoSrc;
              video.addEventListener('canplay', () => {
                // video.play();
              });
            }
          });
        }
      });
    },
    getlikecount(){
      const d = { data: JSON.stringify([this.$f7route.params.Id]) };
      getlikecount(d).then((data) => {
        if (data.Code === "NoError") {
          this.likecountlist = data.Data;
          this.goodflag = data.Data[0].v[1];
          this.goodnum = data.Data[0].v[0];
        }
      });

    },
    newsLike(id,flag){
      if (!this.likeFlag) {
        return;
      }
      this.likeFlag = false;

      const param = {"newsID":id,"isLike":flag};
      const d = { data: JSON.stringify(param) };
      newsLike(d).then((data) => {
        if (data.Code === "NoError") {
          this.getlikecount();
        }
        this.likeFlag = true;
      });
    }
  },
  created() { 
    if (this.$f7route.params.Id) {
      this.newsbymemberget(this.$f7route.params.Id);
      this.getlikecount();
    }
    if (this.$f7route.params.Type == 1) {
      this.type = 1
    }else if(this.$f7route.params.Type == 2){
      this.type = 2
    }else if(this.$f7route.params.Type == 3){
      this.type = 3
    }
  },
  mounted() { 
    
  },
};
</script>
<style lang="less" scoped>
.content{
  padding: 0 10px 10px 10px;
  .newsInfo{
    border-bottom: 1px solid #e5e5e5;
    padding: 7px 0 ;
    .title{
      margin-bottom: 5px;
      font-size: 15px;
      font-weight: bold;
    }
    .bottom{
      color: rgba(153, 153, 153, 1);
      display: flex;
      font-size: 12px;
      position: relative;
      div{
        width: 50%;
      }
      div:nth-child(2){
        text-align: right;
      }
    }
    .good{
      position: absolute;
      right: 10px;
      bottom: 0px;
      display: flex;
      align-items: center;
    }
  }
  .sub{
    color: #939393;
    font-weight: normal;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 6px;
    background: #f7f7f7;
    margin: 10px 0;
  }
}

</style>